"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { withBasePath } from "@/lib/base-path";

/**
 * 项目级错误边界：项目工作台里的异常不该把整个应用打白屏，
 * 且要提供"回到项目列表"的退路（而不是只重试）。
 */
export default function ProjectError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations("common");

  useEffect(() => {
    console.error("[error-boundary][project]", error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 p-6 text-center">
      <h1 className="text-lg font-medium text-foreground">{t("errorTitle")}</h1>
      <p className="max-w-md text-sm text-muted-foreground">{t("errorHint")}</p>
      {error.digest ? (
        <p className="font-mono text-xs text-muted-foreground">digest: {error.digest}</p>
      ) : null}
      <div className="mt-2 flex gap-2">
        <Button onClick={() => reset()}>{t("retry")}</Button>
        <Button
          variant="outline"
          onClick={() => {
            window.location.href = withBasePath("/");
          }}
        >
          {t("backHome")}
        </Button>
      </div>
    </div>
  );
}
